import { AutoColumn } from 'components/Column'
import styled from 'styled-components/macro'

export const PaddedColumn = styled(AutoColumn)`
  padding: 20px 20px 0px 20px;
`
